import { FC } from 'react';
import { TimerContainer } from '../css';
import { TimerVector } from '../img';
import { useCountDown } from 'shared/hooks/use-count-down';

const Timer: FC<{ date: number; setEnd: () => void }> = ({ date, setEnd }) => {
	const { minutes, seconds } = useCountDown(date);
 	if (minutes === '00'&& seconds === '00') {
		setEnd()
	}
	return (
		<TimerContainer>
			<div className='timer_scope'>
				<div className='timer_item'>
					<TimerVector />
					<div className='time'>{minutes.toString()[0]}</div>
				</div>
				<div className='timer_item'>
					<TimerVector />
					<div className='time'>{minutes.toString()[1]}</div>
				</div>
			</div>
			<div className='colon'>:</div>
			<div className='timer_scope'>
				<div className='timer_item'>
					<TimerVector />
					<div className='time'>{seconds.toString()[0]}</div>
				</div>
				<div className='timer_item'>
					<TimerVector />
					<div className='time'>{seconds.toString()[1]}</div>
				</div>
			</div>
		</TimerContainer>
	);
};

export default Timer;
